import React, { useEffect, useState, useCallback, useRef } from "react";

import { Container, Row, Col, Modal, Spinner } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
import { connect } from "react-redux";
import "./chatAfterAppoitment.css";
import * as actions from "../../../../store/actions";
import TextInput from "../../../../components/formElements/input/TextInput";
import AppointmentIcon from "../../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import { DEFAULT_PIC } from "../../../../constants/image";
import {
  parseDateToLocal,
  parseUTCtoLocalDateTime,
} from "../../../../utils/parseDateTime";
import FileAttachment from "../../../../components/formElements/file/FileAttachment";
import { toast } from "react-toastify";
import { getUserData } from "../../../../utils/localStorage";
import constants from "../../../../constants";
import { uploadFileToS3 } from "../../../../store/actions/index";
import moment from "moment";
import { useDispatch } from "react-redux";

const ChatAfterAppointment = ({
  appointment,
  getChatDetail,
  chat_details,
  updateChatDetail,
  parentCallback,
  show,
  clearChatData,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [message, setMessage] = useState([]);
  const [messages_array, setMessagesArray] = useState([]);
  const [onMessage, setOnMessage] = useState(true);
  const [sender_array, setSenderMessagesArray] = useState([]);
  const [alert,setAlert]=useState(false)
  const [flag,setFlag]=useState(true)

  let dispatch = useDispatch();
  const userData = getUserData();


  useEffect(() => {
    clearChatData();
    if (appointment?.chat_ids!=null){
      setAlert(true)
      setFlag(false)
    getChatDetail(appointment?.chat_ids[0]["id"], () => {
      console.log("in use effect API call");
    });
   }
    dispatch(actions.onMessageNotification({ is_chat_notification: false }));

    //eslint-disable-next-line
  }, [chat_details.is_chat_notification]);

  useEffect(() => {
    chatMessageDetail();
  });

  const chatMessageDetail = () => {
    if (chat_details?.after_call_chat.length > 0) {
      const chatData = chat_details?.after_call_chat[0];
      const postChat = chatData[0];
      const parsedChatData = postChat["message"];

      if (parsedChatData) {
        setMessagesArray(parsedChatData);
      }

      console.log(parsedChatData, "parsedChatData");
    }
  };

  const chat_message = {
    dateTime:
      moment(new Date()).format("YYYY-MM-DD") +
      " " +
      moment(new Date()).utc().format("HH:mm:ss"),

    isDocument: false,
    message: inputValue,
    name: userData?.firstName + " " + userData?.lastName,
    userId: userData?.user,
    appointment: appointment?.id,
    receiver: appointment?.patient_detail?.user
      ? appointment?.patient_detail?.user
      : appointment?.parent_details?.user,
    sender: appointment?.doctor_detail?.user,
   type: appointment?.is_visit_now ? "VISIT_NOW" : "APPOINTMENT",
    
  };
  

  const msg_send_payload = {
    dateTime:
      moment(new Date()).format("YYYY-MM-DD") +
      " " +
      moment(new Date()).utc().format("HH:mm:ss"),
    isDocument: false,
    message: inputValue,
    name: userData?.firstName + " " + userData?.lastName,
    userId: userData?.user,
    appointment: appointment?.id,
    receiver: appointment?.patient_detail?.user
      ? appointment?.patient_detail?.user
      : appointment?.parent_details?.user,
    sender: appointment?.doctor_detail?.user,
    type: appointment?.is_visit_now ? "VISIT_NOW" : "APPOINTMENT",
   
  };

  const appointment_update = parseDateToLocal(moment(appointment.updated_at));
  const added_hours_Date = parseDateToLocal(
    moment(appointment_update).add(4, "hours")
  );

  const updatedDate = moment(added_hours_Date);
  const current_date = moment(new Date());

  const updateState = val => {
    setOnMessage(val);
  };

  const handleClick = e => {
    if (onMessage) {
      if (
        (e.target?.value != "" && e.target.value != undefined) ||
        (inputValue != "" && inputValue != undefined)
      ) {
        msg_send_payload["message"] = e.target?.value
          ? e.target?.value
          : inputValue;
        chat_message["message"] = e.target?.value
          ? e.target?.value
          : inputValue;
        if (messages_array) {
          messages_array.push(chat_message);
        }

        sender_array.push(msg_send_payload);
        setSenderMessagesArray(sender_array);
        setMessagesArray(messages_array);

        updateChatDetail(
          appointment?.chat_ids[0]["id"],
          msg_send_payload,
          () => {
            console.log("after send messae update");
          }
        );
      }
      updateState(false);
    }
  };

  const sendAttachment = (chat_message, img) => {
    if (messages_array) {
      messages_array.push(chat_message);
    }
    setMessagesArray(messages_array);

    msg_send_payload["message"] = img;
    msg_send_payload["isDocument"] = true;

    sender_array.push(msg_send_payload);
    setSenderMessagesArray(sender_array);

    updateChatDetail(appointment?.chat_ids[0]["id"], msg_send_payload, () => {
      console.log("after send messae update");
    });
    dispatch(actions.onMessageNotification({ is_chat_notification: true }));
  };

  let count = 0;
  const onUploadFile = file => {
    console.log(file, "file");
    const documents = uploadFileToS3(
      file["chat_after_call_doc"][0] || undefined
    );

    documents.then(data => {
      const imgUrl = data.location;

      if (imgUrl) {
        if (count == 0) {
          chat_message["message"] = imgUrl;
          chat_message["isDocument"] = true;
          sendAttachment(chat_message, imgUrl);
          count = count + 1;
        }
      }
    });
  };

  const handleClose = () => {
    dispatch(actions.onMessageNotification({ is_chat_notification: false }));
    setMessagesArray([]);
    parentCallback();
  };

  const onFileError = error => {
    toast.error(error, {
      position: constants.TOAST_POSITION,
    });
  };

  const scrollToBottomModel = () => {
    const scrollingElement = document.getElementById("post-chat");
    scrollingElement.scrollTop = scrollingElement.scrollHeight;
  };

  messages_array.sort(function compare(a, b) {
    var dateA = new Date(a.dateTime);
    var dateB = new Date(b.dateTime);
    return dateA - dateB;
  });
  

  return (
    <>
      <Modal
        show={show}
        aria-labelledby="contained-modal-title-vcenter"
        style={{
          inset: "4% auto auto 32%",
        }}
      >
        <Modal.Header style={{ height: "66px" }}>
          <Modal.Title>
            <p style={{ textAlign: "left" }}>
              <img
                src={appointment?.patient_detail?.image || DEFAULT_PIC}
                className="profile-image-secondary"
                alt={appointment?.id}
              />
              <span className="patient-name">
                {appointment.patient_detail.first_name}{" "}
                {appointment.patient_detail.last_name}{" "}
              </span>
            </p>
          </Modal.Title>
          <button
            onClick={() => handleClose()}
            className="close-chat fileClose-chat"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body
          className="show-grid"
          scrollable={true}
          style={{
            maxHeight: "calc(100vh - 210px)",
            overflowY: "auto",
            height: "590px",
          }}
          ref={input => scrollToBottomModel()}
          id="post-chat"
        >
          <Container fluid="md">
            {messages_array &&
              messages_array?.map((test, index) => {
                return (
                  <Row key={index}>
                    <Col>
                      <div
                        style={{
                          textAlign:
                            userData?.user == test.userId ? "right" : "left",
                        }}
                      >
                        {appointment?.chat_ids &&(<span style={{ fontSize: "13px" }}>{test.name}</span>)}{" "}
                        <br />
                        {appointment?.chat_ids &&(<span
                          style={{
                            border: "1px solid",
                            padding: "2px 15px 3px 7px",
                            borderRadius: "6px",
                            color: "var(--icon-color)",
                            fontSize: "16px",
                            overflowWrap: "break-word",
                          }}
                        >
                          {test.isDocument ? (
                            <a href={test.message} target="_blank">
                              <AppointmentIcon type="documentIconAfterCall" />
                              {test.message?.split("/")?.pop()}
                            </a>
                          ) : (
                            test.message
                          )}
                        </span>)}
                        <br />
                        {appointment?.chat_ids &&(<span style={{ fontSize: "13px" }}>
                          {message &&
                            test.dateTime &&
                            parseUTCtoLocalDateTime(test.dateTime)}
                        </span>)}
                      </div>
                    </Col>
                  </Row>
                );
              })}
          </Container>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "gainsboro", height: "66px" }}>
          <Container>
            {updatedDate && current_date && updatedDate > current_date ? (
              <Row>
                {alert && (<Col xs lg="2">
                  <span>
                    <FileAttachment
                      name="chat_after_call_doc"
                      onChange={file => {
                        onUploadFile(file);
                      }}
                      onError={error => onFileError(error)}
                    />
                  </span>
                </Col>)}
                {alert &&(<Col xs={12} md={8}>
                  <span>
                    <TextInput
                      autoFocus
                      placeholder="Message..."
                      className="chat-box-after-call"
                      value={inputValue}
                      onChange={val => {
                        setInputValue(val);
                        setOnMessage(true);
                      }}
                      onKey={ev => {
                        if (ev.key === "Enter") {
                          handleClick(ev);
                          setInputValue("");
                          ev.preventDefault();
                        }
                      }}
                    />
                  </span>
                </Col>)}
                {alert &&(<Col xs lg="2">
                  <div>
                    <AppointmentIcon
                      className="chat-msg-send"
                      type="msgSend"
                      onClick={e => {
                        handleClick(e);
                        e.preventDefault();
                        setInputValue("");
                      }}
                    />
                  </div>
                </Col>)}
                {flag &&(<div
                style={{
                  textAlign: "center",
                  marginLeft:"30%",
                  color: "var(--icon-color)",

                  fontSize: "17px",
                }}
              >
                You can not chat
              </div>)}
              </Row>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  color: "var(--icon-color)",

                  fontSize: "17px",
                }}
              >
                Messages can only be sent upto 4 hours after video call
              </div>
            )}
          </Container>
        </Modal.Footer>
      </Modal>
    </>
  );
};
const mapStoreToProps = ({ dashboard }) => ({
  chat_details: dashboard.ongoingAppointment,
});

const mapDispatchToProps = dispatch => ({
  getChatDetail: (chatId, cb) => dispatch(actions.getChatDetail(chatId, cb)),
  updateChatDetail: (chatId, messages_array, cb) =>
    dispatch(actions.updateChatDetail(chatId, messages_array, cb)),
  deleteFileFromS3: (file, cb) => dispatch(actions.deleteFileFromS3(file, cb)),
  clearChatData: () => dispatch(actions.clearChat()),
});

export default connect(
  mapStoreToProps,
  mapDispatchToProps
)(ChatAfterAppointment);